import styled from 'styled-components';

export const ContainerGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 24px;
    gap: 0 24px;

    & > * {
        flex: 1 1 calc(50% - 48px);
    }
`;
